define(['jquery', 'availabilityForm', 'basket', 'bootstrap', 'matchHeight'], function($, availabilityForm, basket, bootstrap, matchHeight) {
    var AJAX_URL = '/wp-admin/admin-ajax.php';
    var offers;
    var render = function($container, params, cb) {
        $('.loader').removeClass('hidden');
        var request = Object.assign({ action: 'get_rooms' }, availabilityForm.get());

        if (params) {
            request = Object.assign(request, params);
        }

        $.post(AJAX_URL, request)
            .done(function(response) {
                $container.html(response);
                bindButtons($container);
                $('.carousel', $container).carousel({
                    interval: false
                });
                $('.col-equal', $container).matchHeight({ byRow: false });

                if ($.isFunction(cb)) {
                    cb();
                }
            })
            .fail(function() {
                console.log('Room request error', request);
            })
            .always(function() {
                $('.loader').addClass('hidden');
            });
    };
    var bindButtons = function($container) {
        $('[data-action="add-to-basket"]', $container).click(function() {
            var item = Object.assign({
                    room_code: $(this).data('room-code'),
                    rate_plan: $(this).data('rate-plan'),
                    nights: $(this).data('nights'),
                    is_offer: $(this).data('offer'),
                    room_name: $(this).parents('.room').find('.room-title').text()
                },
                availabilityForm.get()
            );

            basket.add(item);
        });
        $('[data-action="toggle-related-offers"]', $container).click(function(e) {
            e.preventDefault();

            var $this = $(this);
            var $item = $this.parents('.item');
            var $relatedOffersContainer = $('[data-bind="related-offers"]', $item);

            if ($this.hasClass('open')) {
                $this.removeClass('open');
                $relatedOffersContainer.html('');
            } else {
                var roomCode = $this.data('room-code');

                offers.render($relatedOffersContainer, { room_code: roomCode }, function() {
                    $this.addClass('open');
                    bindButtons($relatedOffersContainer);
                    $('[data-action="close-related-offers"]', $relatedOffersContainer).click(function() {
                        //call toggle button to close
                        $this.click();
                    });

                    var promoCodeInUse = ($('[name="promo_code"]').val() !== '');

                    if (!promoCodeInUse) {
                        $('[data-action="add-to-basket"]', $relatedOffersContainer).attr('data-offer', true);
                    }
                });
            }
        });
    };

    return {
        render: render,
        setOffersDependancy: function(module) {
            offers = module;
        }
    };
});